import { Ref } from "@vue/composition-api";

export function genericSort<T>(
  items: T[],
  sortAsc: Ref<boolean>,
  sortKey: Ref<keyof T>,
  newSortKey: keyof T,
): T[] {
  // the key is being sorted the same
  // flip the order
  if (sortKey.value === newSortKey) {
    sortAsc.value = !sortAsc.value;
  } else {
    // reset to true if the key is different
    sortAsc.value = true;
  }
  sortKey.value = newSortKey;

  let gtValue = sortAsc.value ? 1 : -1;
  let ltValue = sortAsc.value ? -1 : 1;

  items.sort((a: any, b: any) => {
    if (a[sortKey.value] > b[sortKey.value]) {
      return gtValue;
    } else if (a[sortKey.value] < b[sortKey.value]) {
      return ltValue;
    } else {
      return 0;
    }
  });

  return items;
}

export function sortIcon(
  sortAsc: Ref<boolean>,
  sortKey: Ref<string>,
  currentSortKey: string,
) {
  if (currentSortKey === sortKey.value) {
    if (sortAsc.value) {
      return "sort-up";
    } else {
      return "sort-down";
    }
  } else {
    return "sort";
  }
}
